import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC36BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_36, actualizarFC_36Estatus, actualizarFC_36Solicitud,
    actualizarFileFC_36, eliminarFileFC_36,
    agregarFileFC_36,
} from '../../../redux/DucksBeneficiario/FC_36Ducks';
import moment from 'moment'
import ArchivosPrediosViveros from '../../ArchivosComponents/ArchivosPrediosViveros';
import ArchivosInstalacionesFC_36 from '../../ArchivosComponents/ArchivosInstalacionesFC_36';
import ArchivosMarcaFC_36Component from '../../ArchivosComponents/ArchivosMarcaFC_36Component';
import { ArchivoOpcionalComponent } from '../../ArchivosComponents/ArchivoOpcionalComponent'

const DocumentacionFC_36Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_36Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_36Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesApoderados = useSelector(store => store.FC_36Solicitud.filesApoderados)
    const filesPersonasAutorizadas = useSelector(store => store.FC_36Solicitud.filesPersonasAutorizadas)
    const filesDomiciliosFiscales = useSelector(store => store.FC_36Solicitud.filesDomiciliosFiscales)
    const filesPrediosDuck = useSelector(store => store.FC_36Solicitud.filesPredios)
    const filesViverosDuck = useSelector(store => store.FC_36Solicitud.filesViveros)
    let documentacionRepresentanteLegalMap = useSelector(store => store.FC_36Solicitud.filesMap)
    let documentacionPersonaAutorizadaMap = useSelector(store => store.FC_36Solicitud.filesMap)
    let filesViverosMap = useSelector(store => store.FC_36Solicitud.filesViverosMap)
    let filesPrediosMap = useSelector(store => store.FC_36Solicitud.filesPrediosMap)
    let documentacionInstalacionMap = useSelector(store => store.FC_36Solicitud.documentacionInstalacionMap)
    let documentacionResponsableMap = useSelector(store => store.FC_36Solicitud.documentacionResponsableMap)
    let documentacionMarcaMap = useSelector(store => store.FC_36Solicitud.documentacionMarcaMap)
    let documentacionMarcaProductoMap = useSelector(store => store.FC_36Solicitud.documentacionMarcaProductoMap)
    const filesInstalacionesDuck = useSelector(store => store.FC_36Solicitud.filesInstalaciones)
    const opcionesFilesInstalacionesDuck = useSelector(store => store.FC_36Solicitud.opcionesFilesInstalaciones)
    const filesResponsablesDuck = useSelector(store => store.FC_36Solicitud.filesResponsables)
    const filesActualizacionResponsablesDuck = useSelector(store => store.FC_36Solicitud.filesActualizacionResponsables)
    const filesMarcasDuck = useSelector(store => store.FC_36Solicitud.filesMarcas)
    const filesMarcasBebidasDuck = useSelector(store => store.FC_36Solicitud.filesMarcasBebidas)

    const filesGeneralesDuck = useSelector(store => store.FC_36Solicitud.filesGenerales)


    let anexoArchivosRepresentantesMap = useSelector(store => store.FC_36Solicitud.anexoArchivosRepresentantesMap)
    let anexoArchivosGenerales = []
    let anexoArchivosPersonaAutorizadaMap = useSelector(store => store.FC_36Solicitud.anexoArchivosPersonaAutorizadaMap)
    let anexoArchivosDomicilioFiscalMap = useSelector(store => store.FC_36Solicitud.anexoArchivosDomicilioFiscalMap)
    let anexoArchivosPrediosMap = useSelector(store => store.FC_36Solicitud.anexoArchivosPrediosMap)

    let anexoArchivosViverosMap = useSelector(store => store.FC_36Solicitud.anexoArchivosViverosMap)
    let anexoArchivosMarcasMap = useSelector(store => store.FC_36Solicitud.anexoArchivosMarcasMap)
    let anexoArchivosMarcasBebidaMap = useSelector(store => store.FC_36Solicitud.anexoArchivosMarcasBebidaMap)
    let anexoArchivosInstalacionesMap = useSelector(store => store.FC_36Solicitud.anexoArchivosInstalacionesMap)
    let anexoArchivosResponsablesInstalacionesMap = useSelector(store => store.FC_36Solicitud.anexoArchivosResponsablesInstalacionesMap)
    let anexoArchivosResponsablesInstMap = useSelector(store => store.FC_36Solicitud.anexoArchivosResponsablesInstMap)

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)
    const opcionesFilesPredios = useSelector(store => store.FC_36Solicitud.opcionesFilePredio)
    const opcionesFilesViveros = useSelector(store => store.FC_36Solicitud.opcionesFileVivero)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        let filterResponsable = data.fc_36_anexoapoderadoslegales?.filter(anexo => anexo?.alta == true)
        let filterPersona = data.fc_36_anexopersonasautorizadas?.filter(anexo => anexo?.alta == true)
        let filterDomicilio = data.fc_36_anexodomiciliosfiscales?.filter(anexo => anexo?.alta == true)
        let filterResponsablesInst = data.fc_36_actualizacionresponsableinstalaciones?.filter(anexo => anexo?.alta == true)

        let countArchivos = 0
        if (data?.fc_36_anexomarcas?.filter(anexo => anexo.alta == true)?.length > 0 || data?.fc_36_anexomarcasproductoconmezcal?.filter(anexo => anexo.alta == true)?.length > 0 ||
            data?.fc_36anexo?.filter(anexo => anexo.alta == true)?.length > 0) countArchivos += 1
        if (data.cambioresponsable) countArchivos += filterResponsable.length * 2
        if (data.cambiorepresentante) countArchivos += filterPersona.length
        if (data.actualizaciondomicilio) countArchivos += filterDomicilio.length * 2
        if (data.actualizarmarcas) countArchivos += contadorMarcas()
        if (data.actualizacionprediosviveros) countArchivos += contadorPredios()
        if (data.cambioresponsableinst) countArchivos += filterResponsablesInst.length
        if (data.actualizacioninstalaciones || (data.actualizacioncadena && data.productormezcal && data.productormezcalaltabaja) ||
            (data.actualizacioncadena && data.envasador && data.envasadoraltabaja)) countArchivos += contadorInstalaciones()
        if (data.actualizacioncadena && !data.productormezcal && data.productormezcalaltabaja) countArchivos += data.fc_36_anexomarcas.length + data.fc_36_anexomarcasproductoconmezcal.length
        if (data.actualizacioncadena && !data.envasador && data.envasadoraltabaja) countArchivos += data.fc_36_anexomarcas.length + data.fc_36_anexomarcasproductoconmezcal.length
        const totalFilesPersonas = (filesPersonasAut?.filter(file => file?.estatus === true)).length
        const totalFilesResponsables = (filesApoderadosLeg?.filter(file => file?.estatus === true)).length
        const totalFilesDomicilio = (filesDomicilioFsical?.filter(file => file?.estatus === true)).length
        const totalFilesMarcas = (filesMarcas?.filter(file => file?.estatus === true)).length
        const totalFilesMarcasBebidas = (filesMarcasProduct?.filter(file => file?.estatus === true)).length
        const totalFilesResponsableInst = (filesActualizacionResponsables?.filter(file => file?.estatus === true)).length
        const totalFilesViveros = (filesViveros?.filter(file => file?.estatus === true)).length
        const totalFilesPredios = (filesPredios?.filter(file => file?.estatus === true)).length
        const totalFilesInstalaciones = (filesInstalaciones?.filter(file => file?.estatus === true)).length
        const totalFilesInstalacionesResponsables = (filesResponsables?.filter(file => file?.estatus === true)).length
        const totalFilesGenerales = (filesGenerales?.filter(file => file?.estatus === true)).length

        const contadorArchivo = totalFilesPersonas + totalFilesResponsables + totalFilesDomicilio + totalFilesMarcas +
            totalFilesMarcasBebidas + totalFilesResponsableInst + totalFilesViveros + totalFilesPredios + totalFilesInstalaciones +
            totalFilesInstalacionesResponsables + totalFilesGenerales

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc36_solicitudactualizacion: data.idfc36_solicitudactualizacion }
            await dispatch(actualizarFC_36Solicitud(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc36_solicitudactualizacion
            const estatusNuevo = 2
            const idCliente = null
            const tablaFC_36 = 10
            const tabla = tablaFC_36
            await dispatch(actualizarFC_36Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_36())
            setEnvioCorrecto(true)
        }
    }
    const contadorMarcas = () => {
        let contador = 0
        if (data.comercializadormezcal || data.actualizarmarcas) {
            let filtro = data.fc_36_anexomarcas?.filter(anexo => anexo?.alta == true)
            if (filtro.length > 0 && !data.envasador && !data.productormaguey) contador += (filtro.length * 2)
            if (filtro.length > 0 && !data.envasador && data.productormaguey) contador += (filtro.length * 2)
            if (filtro.length > 0 && data.envasador && !data.productormaguey) contador += (filtro.length * 1)
            if (filtro.length > 0 && data.envasador && data.productormaguey) contador += filtro.length
            for (const marca of data.fc_36_anexomarcas) {
                if (marca?.alta == true) {
                    if (marca.registrosi && marca.idtitularidaddemarca == 1) contador += 1
                    if (marca.registrosi && marca.idtitularidaddemarca == 3) contador += 2
                    if (marca.registrosi && marca.idtitularidaddemarca == 4) contador += 2
                    if (marca.registrosi && marca.idtitularidaddemarca == 5) contador += 3
                    if (marca.registrosi && marca.idtitularidaddemarca == 6) contador += 2
                    if (marca.registrono && marca.idtitularidaddemarca == 2) contador += 2
                    if (marca.registrono && marca.idtitularidaddemarca == 5) contador += 3
                    if (marca.registrono && marca.idtitularidaddemarca == 6) contador += 3
                }
            }
        }

        if (data.comercializadorbebidasconmezcal || data.actualizarmarcas) {
            let filtroMarcasBebida = data?.fc_36_anexomarcasproductoconmezcal?.filter(anexo => anexo?.alta == true)
            if (filtroMarcasBebida.length > 0 && !data.envasador && !data.productormaguey) contador += (filtroMarcasBebida.length * 2)
            if (filtroMarcasBebida.length > 0 && !data.envasador && data.productormaguey) contador += (filtroMarcasBebida.length * 2)
            if (filtroMarcasBebida.length > 0 && data.envasador && !data.productormaguey) contador += (filtroMarcasBebida.length * 1)
            if (filtroMarcasBebida.length > 0 && data.envasador && data.productormaguey) contador += filtroMarcasBebida.length
            for (const marca of data.fc_36_anexomarcasproductoconmezcal) {
                if (marca?.alta == true) {
                    if (marca.registrosi && marca.idtitularidaddemarca == 1) contador += 1
                    if (marca.registrosi && marca.idtitularidaddemarca == 3) contador += 2
                    if (marca.registrosi && marca.idtitularidaddemarca == 4) contador += 2
                    if (marca.registrosi && marca.idtitularidaddemarca == 5) contador += 3
                    if (marca.registrosi && marca.idtitularidaddemarca == 6) contador += 2
                    if (marca.registrono && marca.idtitularidaddemarca == 2) contador += 2
                    if (marca.registrono && marca.idtitularidaddemarca == 5) contador += 3
                    if (marca.registrono && marca.idtitularidaddemarca == 6) contador += 3
                }
            }
        }

        return contador
    }
    const contadorPredios = () => {
        let contador = 0
        if (data.fc_36_anexoviveros.length > 0 && data.viverista) {
            for (const i in opcionFileVivero) {
                if (opcionFileVivero[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFileVivero[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFileVivero[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFileVivero[i].opcionFile === 'contratocompraventa') contador += 3
            }
            // contador += predios.length
            let filPredio = data.fc_36_anexoviveros.filter(anexo => anexo.alta == true)
            if (opcionFileVivero.length !== filPredio.length) contador++
        }
        if (data.fc_36_anexopredio.length > 0 && data.productormaguey) {
            // contador += productor.length
            for (const i in opcionFilePredio) {
                if (opcionFilePredio[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFilePredio[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFilePredio[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFilePredio[i].opcionFile === 'contratocompraventa') contador += 3
            }
            let filVivero = data.fc_36_anexopredio.filter(anexo => anexo.alta == true)
            if (opcionFilePredio.length !== filVivero.length) contador++
        }
        return contador
    }
    const contadorInstalaciones = () => {
        let contador = 0
        if (data.fc_36anexo.length > 0) {
            // contador += anexoInstalaciones.length
            for (const i in opcionFileInstalacion) {
                if (opcionFileInstalacion[i].opcionFile === 'copiatitulopropiedad') contador++
                else if (opcionFileInstalacion[i].opcionFile === 'contratoarrendamientopublico') contador++
                else if (opcionFileInstalacion[i].opcionFile === 'contratoarrendamientoprivado') contador += 3
                else if (opcionFileInstalacion[i].opcionFile === 'contratocomodatopublico') contador += 1
                else if (opcionFileInstalacion[i].opcionFile === 'contratocomodatoprivado') contador += 3
            }
            let filterInstalaciones = []
            if (!data.cambiorazon) filterInstalaciones = data.fc_36anexo.filter(anexo => anexo.alta == true)
            else filterInstalaciones = data.fc_36anexo
            if (opcionFileInstalacion.length !== filterInstalaciones.length) contador++
            for (const i in data.fc_36anexo) {
                if (data.fc_36anexo[i].alta) contador += data.fc_36anexo[i].fc_36informaciongeneral.responsables.length
            }
        }
        return contador
    }
    React.useEffect(() => {
        if (filesApoderados) {
            let newFiles = []
            for (const file in filesApoderados) {
                const { ...newFile } = filesApoderados?.[file]
                newFiles.push(newFile)
            }
            setFileApoderadosLeg(newFiles)
        }
    }, [data])

    React.useEffect(() => {
        if (filesPersonasAutorizadas) {
            let newFiles = []
            for (const file in filesPersonasAutorizadas) {
                const { ...newFile } = filesPersonasAutorizadas?.[file]
                newFiles.push(newFile)
            }
            setFilePersonasAut(newFiles)
        }
    }, [data])

    React.useEffect(() => {
        if (filesPrediosDuck) {
            let newFiles = []
            for (const file in filesPrediosDuck) {
                const { ...newFile } = filesPrediosDuck?.[file]
                newFiles.push(newFile)
            }
            setFilePredios(newFiles)
        }
    }, [data])
    React.useEffect(() => {
        if (filesDomiciliosFiscales) {
            let newFiles = []
            for (const file in filesDomiciliosFiscales) {
                const { ...newFile } = filesDomiciliosFiscales?.[file]
                newFiles.push(newFile)
            }
            setFileDomicilioFiscal(newFiles)
        }
    }, [data])
    React.useEffect(() => {
        if (filesViverosDuck) {
            let newFiles = []
            for (const file in filesViverosDuck) {
                const { ...newFile } = filesViverosDuck?.[file]
                newFiles.push(newFile)
            }
            setFileViveros(newFiles)
        }
    }, [data])
    React.useEffect(() => {
        if (opcionesFilesViveros) {
            let newOpciones = []
            for (const opcion of opcionesFilesViveros) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileVivero(newOpciones)
        }
        if (opcionesFilesPredios) {
            let newOpciones = []
            for (const opcion of opcionesFilesPredios) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFilePredio(newOpciones)
        }
    }, [])
    React.useEffect(() => {
        if (filesActualizacionResponsablesDuck) {
            let newFiles = []
            for (const file in filesActualizacionResponsablesDuck) {
                const { ...newFile } = filesActualizacionResponsablesDuck?.[file]
                newFiles.push(newFile)
            }
            setFilesActualizacionResponsables(newFiles)
        }
    }, [data])
    React.useEffect(() => {
        if (filesMarcasDuck) {
            let newFiles = []
            for (const file in filesMarcasDuck) {
                const { ...newFile } = filesMarcasDuck?.[file]
                newFiles.push(newFile)
            }
            setFilesMarcas(newFiles)
        }
        if (filesMarcasBebidasDuck) {
            let newFiles = []
            for (const file in filesMarcasBebidasDuck) {
                const { ...newFile } = filesMarcasBebidasDuck?.[file]
                newFiles.push(newFile)
            }
            setFilesMarcasProduct(newFiles)
        }
    }, [data])
    React.useEffect(() => {
        //filesInstalacionesFC_36
        if (filesInstalacionesDuck) {
            let newFiles = []
            for (const file of filesInstalacionesDuck) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileInstalaciones(newFiles)
        }
        if (opcionesFilesInstalacionesDuck) {
            let newOpciones = []
            for (const opcion of opcionesFilesInstalacionesDuck) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileInstalacion(newOpciones)
        }
        //filesResponsablesFC_36
        if (filesResponsablesDuck) {
            let newFiles = []
            for (const file of filesResponsablesDuck) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesResponsables(newFiles)
        }
        //filesResponsablesFC_36
        if (filesGeneralesDuck) {
            let newFiles = []
            for (const file of filesGeneralesDuck) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileGenerales(newFiles)
        }
    }, [data])

    //FILES GENERALES
    const [filesGenerales, setFileGenerales] = React.useState([])
    const handdleFileGenerales = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarNuevoArchivoGeneral'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_36archivogeneral
            objectFile.estatus = true
            setFileGenerales(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevGenerales = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesGenerales.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarArchivoGeneral'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarNuevoArchivoGeneral'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFileGenerales(newFiles)
                    return true
                } else {
                    const newFiles = filesGenerales.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileGenerales(newFiles)
                    return false
                }
            }
        }
    }


    //FILES REPRESENTANTE LEGAL
    const [filesApoderadosLeg, setFileApoderadosLeg] = React.useState([])
    const handdleFileApoderadoLeg = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarFC_36ArchivosRepresentantesLegales'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idanexorepresentantelegal
            objectFile.estatus = true
            setFileApoderadosLeg(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevApoderadoLeg = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesApoderadosLeg.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarFC36_ArchivosRepresentantesLegales'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarFC_36ArchivosRepresentantesLegales'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFileApoderadosLeg(newFiles)
                    return true
                } else {
                    const newFiles = filesApoderadosLeg.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileApoderadosLeg(newFiles)
                    return false
                }
            }
        }
    }
    const [filesPersonasAut, setFilePersonasAut] = React.useState([])
    const handdleFilePersonasAut = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarFC_36ArchivosPersonasAutorizadas'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idanexopersonaautorizada
            objectFile.estatus = true
            setFilePersonasAut(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevPersonasAut = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesPersonasAut.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarFC36_ArchivosPersonasAutorizadas'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarFC_36ArchivosPersonasAutorizadas'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFilePersonasAut(newFiles)
                    return true
                } else {
                    const newFiles = filesPersonasAut.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilePersonasAut(newFiles)
                    return false
                }
            }
        }
    }

    const [filesDomicilioFsical, setFileDomicilioFiscal] = React.useState([])
    const handdleFileDomicilioFiscal = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarFC_36ArchivosDomicilioFiscal'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idanexopersonaautorizada
            objectFile.estatus = true
            setFileDomicilioFiscal(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemoveDomicilioFiscal = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesDomicilioFsical.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarFC36_ArchivosDomicilioFiscal'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarFC_36ArchivosDomicilioFiscal'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFileDomicilioFiscal(newFiles)
                    return true
                } else {
                    const newFiles = filesDomicilioFsical.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileDomicilioFiscal(newFiles)
                    return false
                }
            }
        }
    }
    //FILES VIVEROS
    const [filesViveros, setFileViveros] = React.useState([])
    const handdleFileVivero = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarFC_36ArchivosViveros'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosvivero
            objectFile.estatus = true
            setFileViveros(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevVivero = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesViveros.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarFC36_ArchivosViveros'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarFC_36ArchivosViveros'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFileViveros(newFiles)
                    return true
                } else {
                    const newFiles = filesViveros.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileViveros(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFileVivero, setOpcionFileVivero] = React.useState([])
    const handleChangeOptionFileVivero = (option) => {
        setOpcionFileVivero(prev => [...prev, option])
    }
    const handdleRemoveOptionFileVivero = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileVivero.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileVivero(newOptions)
            }
        }
    }
    const deletePrevVivero = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_06/eliminarArchivoVivero'
                    }
                    await dispatch(eliminarFileFC_36(data))
                }
            })
            setFileViveros(newFiles)
        }
    }
    //FILES PREDIOS
    const [filesPredios, setFilePredios] = React.useState([])
    const handdleFilePredio = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarFC_36ArchivosPredios'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivospredio
            objectFile.estatus = true
            setFilePredios(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevPredio = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesPredios.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarFC36_ArchivosPredios'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarFC_36ArchivosPredios'
                    }
                    result = await dispatch(agregarFileFC_06(data))
                }
                if (result.payload.data?.data) {
                    setFilePredios(newFiles)
                    return true
                } else {
                    const newFiles = filesPredios.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilePredios(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFilePredio, setOpcionFilePredio] = React.useState([])
    const handleChangeOptionFilePredio = (option) => {
        setOpcionFilePredio(prev => [...prev, option])
    }
    const handdleRemoveOptionFilePredio = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFilePredio.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFilePredio(newOptions)
            }
        }
    }
    const deletePrevPredio = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_06/eliminarArchivoPredio'
                    }
                    await dispatch(eliminarFileFC_06(data))
                }
            })
            setFilePredios(newFiles)
        }
    }
    //instalaciones
    const [filesInstalaciones, setFileInstalaciones] = React.useState([])
    const handdleFileInstalaciones = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarNuevoArchivoAnexoInstalacion'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosinstalacion
            objectFile.estatus = true
            setFileInstalaciones(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevInstalaciones = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesInstalaciones.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarArchivoAnexoInstalacion'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarNuevoArchivoAnexoInstalacion'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result?.payload?.data?.data) {
                    setFileInstalaciones(newFiles)
                    return true
                } else {
                    const newFiles = filesInstalaciones.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileInstalaciones(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFileInstalacion, setOpcionFileInstalacion] = React.useState([])
    const handleChangeOptionFileInstalacion = (option) => {
        setOpcionFileInstalacion(prev => [...prev, option])
    }
    const handdleRemoveOptionFileInstalacion = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileInstalacion.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileInstalacion(newOptions)
            }
        }
    }
    const deletePrevInstalacion = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_36/eliminarArchivoInstalacion'
                    }
                    await dispatch(eliminarFileFC_36(data))
                }
            })
            setFileInstalaciones(newFiles)
        }
    }

    //FILES RESPONSABLES
    const [filesResponsables, setFilesResponsables] = React.useState([])
    const handdleFileResponsables = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarNuevoArchivoResponsable'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosresponsables
            objectFile.estatus = true
            setFilesResponsables(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevResponsables = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesResponsables.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarArchivoResponsable'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarNuevoArchivoResponsable'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFilesResponsables(newFiles)
                    return true
                } else {
                    const newFiles = filesResponsables.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesResponsables(newFiles)
                    return false
                }
            }
        }
    }

    //FILES ACTUALIZACION RESPONSABLES
    const [filesActualizacionResponsables, setFilesActualizacionResponsables] = React.useState([])
    const handdleFileActualizacionResponsables = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarNuevoArchivoActualizacionResponsable'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_36archivoresponsables
            objectFile.estatus = true
            setFilesActualizacionResponsables(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevActualizacionResponsables = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesActualizacionResponsables.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarArchivoActualizacionResponsable'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarNuevoArchivoActualizacionResponsable'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFilesActualizacionResponsables(newFiles)
                    return true
                } else {
                    const newFiles = filesActualizacionResponsables.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesActualizacionResponsables(newFiles)
                    return false
                }
            }
        }
    }
    const [filesMarcas, setFilesMarcas] = React.useState([])
    const handdleFileMarcas = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarNuevoArchivoMarca'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosmarca
            objectFile.estatus = true
            setFilesMarcas(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevMarcas = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesMarcas.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarArchivoMarca'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarNuevoArchivoMarca'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFilesMarcas(newFiles)
                    return true
                } else {
                    const newFiles = filesMarcas.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesMarcas(newFiles)
                    return false
                }
            }
        }
    }
    //FILES MARCAS PRODUCTO
    const [filesMarcasProduct, setFilesMarcasProduct] = React.useState([])
    const handdleFileMarcasProduct = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_36/agregarNuevoArchivoMarcaBebida'
        }
        const result = await dispatch(agregarFileFC_36(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosmarcaproducto
            objectFile.estatus = true
            setFilesMarcasProduct(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevMarcasProduct = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesMarcasProduct.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_36/actualizarArchivoMarcaBebida'
                }
                const result = await dispatch(actualizarFileFC_36(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_36/agregarNuevoArchivoMarcaBebida'
                    }
                    result = await dispatch(agregarFileFC_36(data))
                }
                if (result.payload.data?.data) {
                    setFilesMarcasProduct(newFiles)
                    return true
                } else {
                    const newFiles = filesMarcasProduct.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesMarcasProduct(newFiles)
                    return false
                }
            }
        }
    }


    const FilesGeneralesAlta = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    {(data.cambiorazon && data.tipoempresa == 'moral') ?
                        <div className={`mb-3 ${estilos.divBorderNaranjaDoc}`}>
                            <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                id={`DGAC`} tabla={"fc_36archivogeneral"} textLabel="Acta constitutiva notariada con Registro Público de Comercio"
                                idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />

                            {/*<ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                id={`DGPN`} tabla={"fc_36archivogeneral"} textLabel="Poder notarial del representante legal o última acta de asamblea notariada."
                                textoTooltip='En caso de no acreditarse en su acta constitutiva' idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />

                            <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                id={`DGIOVREP`} tabla={"fc_36archivogeneral"} textLabel={`Identificación oficial vigente del representante legal: ${data.representantelegal}`}
                                idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />

                            <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                id={'DGRFC'} tabla={"fc_36archivogeneral"} textLabel="Constancia de situación fiscal (RFC)." textoTooltip='No mayor a tres meses de antigüedad'
                                idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />*/}

                            {
                                data.certificacionsi &&
                                <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                    id={'DGC'} tabla={"fc_36archivogeneral"} textLabel={`Certificación de la empresa: ${data.empresacertificadora}`}
                                    idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />
                            }
                        </div> :
                        (data.cambiorazon && data.tipoempresa == 'fisica') ?
                            <div className={`mb-3 ${estilos.divBorderNaranjaDoc}`}>
                                {
                                    <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                        id={'DGIOV'} tabla={"fc_36archivogeneral"} textLabel={`Identificación oficial vigente del solicitante: ${data.actualizacionnombrerazon}`}
                                        idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />
                                }
                                {/*<ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                    id={'DGRFC'} tabla={"fc_36archivogeneral"} textLabel="Constancia de situación fiscal (RFC)." textoTooltip='No mayor a tres meses de antigüedad'
                                    idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />*/}
                                {
                                    data.certificacionsi &&
                                    <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                        id={'DGC'} tabla={"FC_01_anexos"} textLabel={`Documento que acredite su certificación ${data.empresacertificadora}`}
                                        idAnexoFK={data.idfc36_solicitudactualizacion} filesMap={anexoArchivosGenerales} />
                                }
                            </div> : ''
                    }

                    {data?.fc_36_anexoapoderadoslegales?.map((representante, index) => (
                        <>
                            {((representante?.alta) || (data.cambiorazon && representante?.principal && data.tipoempresa == 'moral' && representante.baja != true) ||
                                (data.cambiorazon && !representante?.principal && data.tipoempresa == 'fisica' && representante.baja != true)) ?
                                <div className={`row  ${estilos.divBorderNaranjaDoc}`}>
                                    <label>Documentacion del {representante?.principal ? 'representante' : 'apoderado'} legal: {representante.representantelegal}</label>
                                    <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }}
                                        idAnexoFK={representante.idfc36_anexoapoderadoslegales} id={`DGIOVAP${representante.idfc36_anexoapoderadoslegales}`} tabla={"fc_36archivoresponsablelegal"}
                                        textLabel={`Identificación oficial vigente del ${representante?.principal ? 'representante' : 'apoderado'} legal`} filesMap={anexoArchivosRepresentantesMap} />
                                    <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }}
                                        idAnexoFK={representante.idfc36_anexoapoderadoslegales} id={`DGPNAP${representante.idfc36_anexoapoderadoslegales}`}
                                        tabla={"fc_36archivoresponsablelegal"} textLabel={`Poder notarial o acta de asamblea`} filesMap={anexoArchivosRepresentantesMap} />
                                </div> : ''

                            }
                        </>
                    ))}
                    {data?.fc_36_anexopersonasautorizadas?.map((personaAut, index) => (
                        <>
                            {personaAut?.alta ?
                                <div className={`row  ${estilos.divBorderNaranjaDoc}`}>
                                    <label>Documentacion de alta de la persona autorizada: {personaAut.personaautoriazadaparatramites}</label>
                                    <ArchivoComponent api={{ handdleFile: handdleFilePersonasAut, handdleRemovePrev: handdleRemovePrevPersonasAut, files: filesPersonasAut }}
                                        idAnexoFK={personaAut.idfc36_anexopersonasautorizadas} id={`DGIOVAUT${personaAut.idfc36_anexopersonasautorizadas}`}
                                        tabla={"FC_36_anexopersonaautorizada"} textLabel={`Identificación oficial vigente de la persona autorizada`}
                                        filesMap={anexoArchivosPersonaAutorizadaMap} />
                                </div> : ''
                            }
                        </>
                    ))}
                    {data?.fc_36_anexodomiciliosfiscales?.map((domicilio, index) => (
                        <>
                            {(domicilio?.alta || (data.cambiorazon && domicilio.baja != true)) &&
                                <div className={`row  ${estilos.divBorderNaranjaDoc}`}>
                                    <div className='text-center' style={{ color: 'black' }}><b>Domicilio {domicilio.domicilioprincipal ? 'Fiscal' : 'Sucursal'}: </b>{domicilio.calle + ', ' + domicilio.numerointerior + ', ' + domicilio.numeroexterior + ', ' +
                                        domicilio.colonia + ', ' + domicilio.localidad + ', ' + domicilio.municipio + ', ' + domicilio.estado + ', ' +
                                        domicilio.codigopostal}</div>
                                    <div className='mt-3'></div>
                                    <ArchivoComponent api={{ handdleFile: handdleFileDomicilioFiscal, handdleRemovePrev: handdleRemoveDomicilioFiscal, files: filesDomicilioFsical }}
                                        idAnexoFK={domicilio.idfc36_anexodomiciliosfiscales} id={`DGCSF${domicilio.idfc36_anexodomiciliosfiscales}`}
                                        tabla={"fc_36_anexodomiciliosfiscales"} textLabel={`Constancia de situación fiscal`}
                                        filesMap={anexoArchivosDomicilioFiscalMap} />
                                    <ArchivoComponent api={{ handdleFile: handdleFileDomicilioFiscal, handdleRemovePrev: handdleRemoveDomicilioFiscal, files: filesDomicilioFsical }}
                                        idAnexoFK={domicilio.idfc36_anexodomiciliosfiscales} id={`DGCD${domicilio.idfc36_anexodomiciliosfiscales}`}
                                        tabla={"fc_36_anexodomiciliosfiscales"} textLabel={`Comprobante de domicilio`}
                                        filesMap={anexoArchivosDomicilioFiscalMap} />
                                </div>
                            }
                        </>
                    ))}
                    {(data?.fc_36_anexomarcas?.filter(anexo => anexo.alta == true)?.length > 0 || data?.fc_36_anexomarcasproductoconmezcal?.filter(anexo => anexo.alta == true)?.length > 0 ||
                        data?.fc_36anexo?.filter(anexo => anexo.alta == true)?.length > 0) &&
                        <div className={`row  ${estilos.divBorderNaranjaDoc}`}>
                            <ArchivoComponent api={{ handdleFile: handdleFileGenerales, handdleRemovePrev: handdleRemovePrevGenerales, files: filesGenerales }}
                                idAnexoFK={data.idfc36_solicitudactualizacion} id={`DGCP${data.idfc36_solicitudactualizacion}`} tabla={"fc_36archivogeneral"}
                                textLabel={`Comprobante de pago`} filesMap={anexoArchivosGenerales} />
                            <span style={{ color: 'black', fontSize: '14px', textAlign: 'left' }}> Para realizar el pago correspondiente, solicite su cotización al correo de <u style={{ color: 'blue' }}>info@comercam-dom.org.mx </u>
                                o a los teléfonos: 951 517 45 79 / 951 672 41 95 / 951 672 22 12 </span>
                        </div>
                    }
                </Collapsible>
            </div>
        )
    }

    const FilesActualizacionResponsablesInstalaciones = () => {
        return (
            <div>
                <Collapsible trigger="Documentación para dar de alta responsable de instalaciones" className='mb-3'>
                    {data?.fc_36_actualizacionresponsableinstalaciones?.map((responsable, index) => (
                        responsable.alta === true ?
                            <ArchivoComponent api={{ handdleFile: handdleFileActualizacionResponsables, handdleRemovePrev: handdleRemovePrevActualizacionResponsables, files: filesActualizacionResponsables }}
                                idAnexoFK={responsable.idfc_36_actulizarresponsableinstalaciones} id={`ACTINSTREP${responsable.idfc_36_actulizarresponsableinstalaciones}`} tabla={"fc_36_actualizacionresponsableinstalaciones"}
                                textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`}
                                filesMap={anexoArchivosResponsablesInstMap} />
                            : ''
                    ))}
                </Collapsible>
            </div>
        )
    }
    const viveristaPredioFiles = () => {
        let nameDocumentacion = ''
        if ((data?.viverista && data.fc_36_anexoviveros?.filter(anexo => anexo.alta == true) && data.viveristaaltabaja) ||
            (data.cambiorazon && data.viverista && !data.productormaguey)) nameDocumentacion = 'viverista'
        if ((data?.productormaguey && data?.viverista && data.fc_36_anexoviveros?.filter(anexo => anexo.alta == true) &&
            data.fc_36_anexopredio?.filter(anexo => anexo.alta == true) && data.productormagueyaltabaja && data.viveristaaltabaja) ||
            (data.cambiorazon && data.viverista && data.productormaguey)) nameDocumentacion += 'viverista/productor maguey'
        else if ((data?.productormaguey && data.fc_36_anexopredio?.filter(anexo => anexo.alta == true) && data.productormagueyaltabaja) ||
            (data.cambiorazon && !data.viverista && data.productormaguey)) nameDocumentacion = 'productor maguey'
        return (
            <div>
                <Collapsible trigger={`Agregar documentación de ${nameDocumentacion}`}>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        {data?.fc_36_anexoviveros?.map((vivero, index) => (
                            <Fragment>
                                {(vivero?.alta && (data.actualizacionprediosviveros || data.actualizacioncadena) || (data?.cambiorazon && data.viverista)) ?
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFileVivero, handdleRemovePrev: handdleRemovePrevVivero, files: filesViveros }} idAnexoFK={vivero.idfc_36_anexoviveros}
                                            id={`VIV${vivero.idfc_36_anexoviveros}`} tabla={"fc_36archivovivero"} anexo={vivero} name='Vivero' tipo={'Vivero'}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }}
                                            filesMap={anexoArchivosViverosMap} />
                                    </div>
                                    : ''
                                }</Fragment>
                        ))}
                        {data?.fc_36_anexopredio?.map((predio, index) => (
                            <Fragment>
                                {(predio?.alta && (data.actualizacionprediosviveros || data.actualizacioncadena) || (data?.cambiorazon && data.productormaguey)) ?
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFilePredio, handdleRemovePrev: handdleRemovePrevPredio, files: filesPredios }} idAnexoFK={predio.idfc36_anexopredio}
                                            id={`PRED${predio.idfc36_anexopredio}`} tabla={"fc_36archivopredio"} anexo={predio} name='Predio' tipo={'Predio'}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFilePredio, opcion: opcionFilePredio, handdleRemoveOptionFile: handdleRemoveOptionFilePredio, deletePrevFile: deletePrevPredio }}
                                            filesMap={anexoArchivosPrediosMap} />
                                    </div>
                                    : ''
                                }
                            </Fragment>
                        ))}
                    </div>
                </Collapsible>

            </div>
        )
    }
    const comercializadorFisicaFiles = () => {
        if (((data.comercializadorbebidas || data.comercializadormezcal || data.actualizarmarcas) && !data.actualizacioncadena) ||
            (data.actualizarmarcas && data.cambiorazon && (data.comercializadorbebidas || data.comercializadormezcal)) ||
            (data.actualizacioncadena && ((data.comercializadormezcal && data.comercializadormezcalaltabaja) || (data.comercializadorbebidas && data.comercializadorbebidasaltabaja)))) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                        <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {data.fc_36_anexomarcas.map((marca, index) => (
                                ((marca.alta === true && data.cambiorazon) || marca.alta === true) &&
                                <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                    <label className='label-blanco'>Marca de mezcal: {marca.marca}</label>
                                    <ArchivosMarcaFC_36Component api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }}
                                        idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCAL${marca.idfc36_anexomarcas}`} tabla={"fc_36_archivosmarcas"}
                                        key={index} marca={marca} namePK={'idfc36_anexomarcas'} filesMap={anexoArchivosMarcasMap} />
                                    {!data.envasador &&
                                        <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }}
                                            idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCALCONTRATO${marca.idfc36_anexomarcas}`}
                                            tabla={"fc_36_archivosmarcas"} textLabel="Contrato de maquila con un envasador" filesMap={anexoArchivosMarcasMap} />
                                    }
                                    {!(
                                        (data.productormezcal && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                        ((data.productormaguey || data.productormezcal) && data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                        (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                        (data.productormaguey && data.productormezcal && data.envasador && data.comercializadormezcal && data.comercializadorbebidasconmezcal)
                                    ) &&
                                        <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }}
                                            idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCALCONVENIO${marca.idfc36_anexomarcas}`} tabla={"fc_36_archivosmarcas"}
                                            textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={anexoArchivosMarcasMap} />
                                    }
                                </div>
                            ))
                            }
                            {data.fc_36_anexomarcasproductoconmezcal.map((marca, index) => (
                                ((marca.alta === true && data.cambiorazon) || marca.alta === true) &&
                                <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                    <label className='label-blanco'>Marca para bebidas con mezcal: {marca.marca}</label>
                                    <ArchivosMarcaFC_36Component api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }}
                                        idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCAL${marca.idfc36_anexomarcasproductoconmezcal}`}
                                        tabla={"fc_36_archivosmarcas"} key={index} marca={marca} namePK={'idfc36_anexomarcasproductoconmezcal'}
                                        filesMap={anexoArchivosMarcasBebidaMap} />
                                    {
                                        !data.envasador &&
                                        <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }}
                                            idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONTRATO${marca.idfc36_anexomarcasproductoconmezcal}`}
                                            tabla={"fc_36_archivosmarcas"} textLabel="Contrato de maquila con un envasador" filesMap={anexoArchivosMarcasBebidaMap} />
                                    }
                                    {
                                        !(
                                            (data.productormezcal && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                            ((data.productormaguey || data.productormezcal) && data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                            (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                            (data.productormaguey && data.productormezcal && data.envasador && data.comercializadormezcal && data.comercializadorbebidasconmezcal)
                                        ) &&
                                        <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }}
                                            idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONVENIO${marca.idfc36_anexomarcasproductoconmezcal}`}
                                            tabla={"fc_36_archivosmarcas"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={anexoArchivosMarcasBebidaMap} />
                                    }
                                </div>
                            ))
                            }
                        </div>
                    </Collapsible>

                </div>

            )
        }
        if (data.actualizacioncadena && data.productormezcalaltabaja) {
            return (
                <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                    <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        {data.fc_36_anexomarcas.map((marca, index) => (
                            <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                <label className='label-blanco'>Marca de mezcal: {marca.marca}</label>
                                <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }}
                                    idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCALCONVENIO${marca.idfc36_anexomarcas}`} tabla={"fc_36_archivosmarcas"}
                                    textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={anexoArchivosMarcasMap} />
                            </div>))
                        }
                        {data.fc_36_anexomarcasproductoconmezcal.map((marca, index) => (
                            <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                <label className='label-blanco'>Marca de bebida con mezcal: {marca.marca}</label>
                                <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }}
                                    idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONVENIO${marca.idfc36_anexomarcasproductoconmezcal}`}
                                    tabla={"fc_36_archivosmarcas"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={anexoArchivosMarcasBebidaMap} />
                            </div>))
                        }
                    </div>
                </Collapsible>
            )
        }
        if (data.actualizacioncadena && data.envasadoraltabaja) {
            return (
                <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                    <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        {data.fc_36_anexomarcas.map((marca, index) => (
                            <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                <label className='label-blanco'>Marca de mezcal: {marca.marca}</label>
                                <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }}
                                    idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCALCONTRATO${marca.idfc36_anexomarcas}`}
                                    tabla={"fc_36_archivosmarcas"} textLabel="Contrato de maquila con un envasador" filesMap={anexoArchivosMarcasMap} />
                            </div>
                        ))}
                        {data.fc_36_anexomarcasproductoconmezcal.map((marca, index) => (
                            <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                <label className='label-blanco'>Marca de bebida con mezcal: {marca.marca}</label>
                                <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }}
                                    idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONTRATO${marca.idfc36_anexomarcasproductoconmezcal}`}
                                    tabla={"fc_36_archivosmarcas"} textLabel="Contrato de maquila con un envasador" filesMap={anexoArchivosMarcasBebidaMap} />
                            </div>
                        ))}
                    </div>
                </Collapsible>
            )
        }
    }

    const comercializadorMoralFiles = () => {
        if (data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                        <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.fc_36_anexomarcas.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaFC_36Component api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCAL${marca.idfc36_anexomarcas}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} namePK={'idfc36_anexomarcas'} filesMap={documentacionMarcaMap} />
                                        {
                                            !data.envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCALCONTRATO${marca.idfc36_anexomarcas}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaMap} />
                                        }
                                        {
                                            !(
                                                (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                                (data.productormaguey && data.productormezcal) ||
                                                (data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                (data.productormaguey) && (data.productormezcal) ||
                                                (data.envasador)
                                            ) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc36_anexomarcas} id={`MARCAMEZCALCONVENIO${marca.idfc36_anexomarcas}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaMap} />
                                        }
                                    </div>
                                ))
                            }
                            {
                                data.fc_36_anexomarcasproductoconmezcal.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaFC_36Component api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCAL${marca.idfc36_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} namePK={'idfc36_anexomarcasproductoconmezcal'} filesMap={documentacionMarcaProductoMap} />
                                        {
                                            !data.envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONTRATO${marca.idfc36_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaProductoMap} />
                                        }
                                        {
                                            !(
                                                (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                                (data.productormaguey && data.productormezcal) ||
                                                (data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                (data.productormaguey) && (data.productormezcal) ||
                                                (data.envasador)
                                            ) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc36_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONVENIO${marca.idfc36_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaProductoMap} />
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }
    const instalacionesFiles = () => {
        const filter = data.fc_36anexo.filter(anexo => anexo.alta == true)
        if (((data.productormezcal || data.envasador || data.comercializadorbebidas || data.comercializadormezcal && data.fc_36anexo.length > 0 || data.cambiorazon) && !data.actualizacioncadena) ||
            (data.actualizacioncadena && filter.length > 0) || (data.cambiorazon && data.fc_36anexo?.length > 0)) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación de instalaciones" className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.fc_36anexo.map((anexo, index) => (
                                    ((data.cambiorazon && anexo.baja == false) || anexo.alta) &&
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <h5 className='text-center' style={{ color: 'black' }}>{anexo.idtipoanexo === 1 ? "Unidad de Producción" : anexo.idtipoanexo === 2 ? "Unidad de Envasado" : "Unidad de Almacén"}</h5>
                                        <ArchivosInstalacionesFC_36 api={{ handdleFile: handdleFileInstalaciones, handdleRemovePrev: handdleRemovePrevInstalaciones, files: filesInstalaciones }} idAnexoFK={anexo.idfc_36anexo} id={`INST${anexo.idfc_36anexo}`} tabla={"FC_36_anexosInstalacion"} anexo={anexo}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileInstalacion, opcion: opcionFileInstalacion, handdleRemoveOptionFile: handdleRemoveOptionFileInstalacion, deletePrevFile: deletePrevInstalacion }} filesMap={anexoArchivosInstalacionesMap} />
                                        {anexo.fc_36informaciongeneral.responsables.map((responsable, indexR) => (
                                            (!data.cambiorazon || anexo.alta) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileResponsables, handdleRemovePrev: handdleRemovePrevResponsables, files: filesResponsables }} idAnexoFK={responsable.idfc_36responsabledeinstalacion} id={`INSTREP${anexo.idfc_36anexo}${responsable.idfc_36responsabledeinstalacion}`} tabla={"FC_36_anexosResponsablesInstalacion"}
                                                textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`} filesMap={anexoArchivosResponsablesInstalacionesMap} />
                                        ))}
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {(data.cambioresponsable || data.actualizaciondomicilio || data.cambiorepresentante ||
                        data.actualizacioninstalaciones || data.actualizarmarcas || data?.fc_36anexo?.filter(anexo => anexo.alta == true)?.length > 0 ||
                        data?.fc_36_anexomarcas?.filter(anexo => anexo.alta == true)?.length > 0 ||
                        data?.fc_36_anexomarcasproductoconmezcal?.filter(anexo => anexo.alta == true)?.length > 0)
                        && FilesGeneralesAlta()}
                    {/*FilesGeneralesBaja()*/}
                    {(((data.actualizacioncadena && ((data.viverista && data.viveristaaltabaja) || (data.productormaguey && data.productormagueyaltabaja))) ||
                        (data.actualizacionprediosviveros && !data.cambiorazon)) || (data.cambiorazon && (data.viverista || data.productormaguey))) && viveristaPredioFiles()}

                    {data.cambioresponsableinst && FilesActualizacionResponsablesInstalaciones()}

                    {(((data.actualizacioncadena && ((data.productormezcal && data.productormezcalaltabaja) ||
                        (data.envasador && data.envasadoraltabaja) || (data.comercializadormezcal && data.comercializadormezcalaltabaja)
                        || (data.comercializadorbebidas && data.comercializadorbebidasaltabaja)))
                        || data.actualizacioninstalaciones) || data.cambiorazon) && instalacionesFiles()}

                    {(((data.actualizacioncadena && ((data.comercializadormezcal && data.comercializadormezcalaltabaja) ||
                        (data.comercializadorbebidas && data.comercializadorbebidasaltabaja))) ||
                        (!data.envasador && data.envasadoraltabaja) ||
                        (!data.productormezcal && data.productormezcalaltabaja) ||
                        data.actualizarmarcas) || (data.cambiorazon && (data.comercializadorbebidas || data.comercializadormezcal))) && comercializadorFisicaFiles()}

                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envio</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_36Component)
